import { createRouter, createWebHistory } from 'vue-router';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { nextTick } from "vue";

import SigninView from '../views/SigninView.vue';
import UsersView from '../views/UsersView.vue';
import ModelsView from '../views/ModelsView.vue';
import PayoutView from '../views/PayoutView.vue';
import KycView from '../views/KycView.vue';
import RefPayoutView from '../views/RefPayoutView.vue';

const routes = [
  {
    path: "/",
    name: "sign-in",
    component: SigninView,
    meta: {
      title: "Sign in",
    },
  },

  {
    path: "/sign-in",
    name: "sign-in2",
    component: SigninView,
    meta: {
      title: "Sign in",
    },
  },

  {
    path: "/users",
    name: "users",
    component: UsersView,
    meta: {
      title: "Users",
      requiresAuth: true,
    },
  },

  {
    path: "/models",
    name: "models",
    component: ModelsView,
    meta: {
      title: "Models",
      requiresAuth: true,
    },
  },

  {
    path: "/payouts",
    name: "payouts",
    component: PayoutView,
    meta: {
      title: "Payouts",
      requiresAuth: true,
    },
  },

  {
    path: "/reports",
    name: "reports",
    component: UsersView,
    meta: {
      title: "Reports",
      requiresAuth: true,
    },
  },

  {
    path: "/kyc",
    name: "kyc",
    component: KycView,
    meta: {
      title: "Kyc",
      requiresAuth: true,
    },
  },

  {
    path: "/ref",
    name: "ref",
    component: RefPayoutView,
    meta: {
      title: "Referrals",
      requiresAuth: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return {
      top: 0,
    };
  },
});

const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const removeListener = onAuthStateChanged(
      getAuth(),
      (user) => {
        removeListener();
        resolve(user);
      },
      reject
    );
  });
};

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (await getCurrentUser()) {
      next();
    } else {
      //alert("You do not have access");
      next("/sign-in");
    }
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  nextTick(() => {
    document.title = to.meta.title;
  });
});

export default router
